// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EM-z","twoColumnImage":"FM-z"};